import { IProjectStats } from '../types';
import createEmptyStatsWrapper from './create-empty-stats-wrapper';

const createEmptyProjectStats: () => IProjectStats = () => ({
  ChannelEvent: createEmptyStatsWrapper(),
  EventSessions: createEmptyStatsWrapper(),
  EventSessionsPageViews: createEmptyStatsWrapper(),
  LiveAndOnDemandEventViews: createEmptyStatsWrapper(),
  EventRegistrations: createEmptyStatsWrapper(),
  EventAllChartData: createEmptyStatsWrapper(),
  EventAverageSessionAttendance: createEmptyStatsWrapper(),
  EventUniqueAttendance: createEmptyStatsWrapper(),
  EventAverageUserWatchtime: createEmptyStatsWrapper(),
  EventSessionsListUniqueAttendees: createEmptyStatsWrapper(),
  FirstSessionStartTime: createEmptyStatsWrapper(),
  EventAttendanceRate: createEmptyStatsWrapper(),
  EventTotalInvites: createEmptyStatsWrapper(),
});

export default createEmptyProjectStats;
